import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { ReservationsServices } from '../../../reservation/services';
import { ReservationPendingListPage } from '../../../reservation/reservation-pending-list/reservation-pending-list';
import { ReservationManualCreatePage } from '../../../reservation/reservation-manual-create/reservation-manual-create';
import { ReservationLoaderPage } from '../../../reservation/reservation-loader/reservation-loader';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the HomeDashboardReservationsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-home-dashboard-reservations',
  templateUrl: 'home-dashboard-reservations.html',
})
export class HomeDashboardReservationsPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public http: HttpClient,
    public reservationsServices: ReservationsServices) {

    this.todayReservations();
    this.tomorrowReservations();
    this.tomorrow1Reservations();
    this.tomorrow2Reservations();
    this.pendingReservations();
  }

  today_reservations: any = 0;
  tomorrow_reservations: any = 0;
  tomorrow1_reservations: any = 0;
  tomorrow2_reservations: any = 0;

  tomorrow_date: any;
  tomorrow1_date: any = 0;
  tomorrow2_date: any = 0;

  data_reservations: boolean = false;

  async todayReservations() {
    let date = moment().format("YYYY-MM-DD");
    await this.http.post(this.globals.analytics_path + 'total-reservations/' + this.globals.restaurant_uid + '/' + date, {}).subscribe(async data => {
      this.today_reservations = data;
      this.data_reservations = true;
    },
      err => {
      }
    );
  }
  async tomorrowReservations() {

    let today = moment();
    let date = await today.add(1, 'days').format("YYYY-MM-DD");
    this.tomorrow_date = new Date(date);
    await this.http.post(this.globals.analytics_path + 'total-reservations/' + this.globals.restaurant_uid + '/' + date, {}).subscribe(async data => {
      this.tomorrow_reservations = data;
    },
      err => {
      }
    );
  }
  async tomorrow1Reservations() {

    let today = moment();
    let date = await today.add(2, 'days').format("YYYY-MM-DD");
    this.tomorrow1_date = new Date(date);
    await this.http.post(this.globals.analytics_path + 'total-reservations/' + this.globals.restaurant_uid + '/' + date, {}).subscribe(async data => {
      this.tomorrow1_reservations = data;
    },
      err => {
      }
    );
  }
  async tomorrow2Reservations() {

    let today = moment();
    let date = await today.add(3, 'days').format("YYYY-MM-DD");
    this.tomorrow2_date = new Date(date);
    await this.http.post(this.globals.analytics_path + 'total-reservations/' + this.globals.restaurant_uid + '/' + date, {}).subscribe(async data => {
      this.tomorrow2_reservations = data;
    },
      err => {
      }
    );
  }
  createReservation() {
    if(this.globals.checkLimitsByLicense('reservations', 'calendar')) {
      this.navCtrl.push(ReservationManualCreatePage);
    } else{
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } 
  }

  pending_reservations:any;
  async pendingReservations() {
    this.pending_reservations = await this.reservationsServices.getReservationsByState(this.globals.restaurant_uid, 'pending');
  }

  openPendingReservations(){
    if(this.globals.checkLimitsByLicense('reservations', 'calendar')) {
      this.globals.side_menu_active = 'reservation';
      this.navCtrl.setRoot(ReservationPendingListPage);
    } else{
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } 
  }

  public openReservation() {
    if(this.globals.checkLimitsByLicense('reservations', 'calendar')) {
      this.globals.side_menu_active = 'reservation';
      this.navCtrl.setRoot(ReservationLoaderPage);
    } else{
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }  
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-dashboard-reservations/home-dashboard-reservations.ts